import { SCREENS } from "utils/constants";
import Create from "./Create";
import Detail from "./Detail";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.WEBHOOKS.LIST,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ADMIN.WEBHOOKS.CREATE,
    exact: true,
    element: <Create />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.WEBHOOKS.DETAIL}/:id`,
    exact: true,
    element: <Detail />,
  },
];

export default routes;
